import { gql } from '@apollo/client';

const RESET_STUDY_MUTATION = gql`
  mutation resetStudy($input: ResetStudyInput!) {
    resetStudy(input: $input) {
      isSuccess
      message
    }
  }
`;

export default RESET_STUDY_MUTATION;
